<template>
  <div class="page-box">
    <div class="page-content page-flex-box">
      <template v-if="dateList.length">
        <div class="date-box">
          <div class="date-main">
            <div
              class="date-item"
              v-for="(item, index) in dateList"
              :key="index"
              @click="handleCurrent(item, index)"
            >
              <div :class="{ active: item.dateStr === currentDate }">
                <div class="title">{{ item.weekStr }}</div>
                <div class="date">{{ item.dateStr.substring(5) }}</div>
                <div class="remark">
                  {{ item.isCanAppoint ? "可约" : "不可约" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-box">
          <div
            class="list-box"
            v-for="(item, index) in serviceItemList"
            :key="index"
          >
            <!--标题服务项-->
            <div>
              <div v-if="item.speus && item.speus.length">
                <div class="banner-title-box">
                  <div class="banner-title">{{ item.name }}</div>
                  <div class="item-price">
                    <span class="unit1">¥</span>
                    {{ item.price === 0 ? "免费" : item.price }}
                    <span class="unit2">/{{ item.unit }}</span>
                  </div>
                </div>
                <div class="list-main modality">
                  <div
                    class="service-item"
                    v-for="(speusItem, index) in item.speus"
                    @click="selectItem(selectData, speusItem)"
                    :key="index"
                  >
                    <div
                      class="service-main"
                      :class="{
                        active: currentSeletdTime(
                          speusItem,
                          selectLabelList,
                          selectData
                        ),
                      }"
                    >
                      <img
                        class="check-icon"
                        v-if="
                          currentSeletdTime(
                            speusItem,
                            selectLabelList,
                            selectData
                          )
                        "
                        src="/static/images/check-icon.png"
                      />
                      {{ speusItem.attributeName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="banner-title-box"
              v-if="item.businessHours.length && !item.speus"
            >
              <div class="banner-title">{{ item.name }}</div>
              <div class="item-price">
                <span class="unit1">¥</span>
                {{ item.price === 0 ? "免费" : item.price }}
                <span class="unit2" v-if="item.unit">/{{ item.unit }}</span>
              </div>
            </div>
            <div class="banner-title-box" v-else>
              <div class="banner-title">开始时间</div>
            </div>
            <div class="list-main" v-if="item.businessHours.length">
              <div
                class="list-item"
                v-for="(itemData, itemIndex) in item.businessHours"
                @click="setSelectTime(itemData, item)"
                :key="itemIndex"
              >
                <div
                  class="item-main"
                  :class="{
                    disabled: updateStatus(itemData),
                    active:
                      inquireSelect(item, itemData, selectData) &&
                      itemData.flag,
                  }"
                >
                  <img
                    v-if="
                      inquireSelect(item, itemData, selectData) && itemData.flag
                    "
                    class="check-icon"
                    src="/static/images/check-icon.png"
                  />
                  {{ itemData.startHours }}
                </div>
              </div>

              <!--候补-->
              <div class="candidate-item" v-if="isCandidate(item, index)">
                <div class="candidate-main" @click="handleCandidate(item)">
                  <span>候补</span>
                  <span>></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-box appointment-box">
          <div class="appointment-text" v-if="!currentTime">
            {{ currentDate | formatDate("yyyy年MM月dd日") }}
            <span>当前未选择服务</span>
          </div>

          <div class="appointment-text" v-else>
            {{ currentTime | formatDate("yyyy年MM月dd日 hh:mm") }}
            <span v-if="isExist(selectLabelList, currentPrimaryKey)"
              >的{{
                selectLabelList[currentPrimaryKey].selectNameList.toString()
              }}服务</span
            >
            <span v-else>的{{ currentServeName }}服务</span>
          </div>
          <div class="appointment-btn" @click="handleImmediatelyBook">
            立即预约
          </div>
        </div>
      </template>
      <van-empty
        class="custom-image"
        v-if="!dateList.length"
        image="https://img.yzcdn.cn/vant/custom-empty-image.png"
        description="暂无可预约日期"
      />
    </div>
  </div>
</template>

<script>
import {
  getMakeAnAppointmentTime,
  serviceDateList,
  commodityConfigIndo,
  candidateStatus,
} from "@/api/index";
import utils from "@/common/js/utils";
export default {
  data() {
    return {
      // 可预约时间
      dateList: [],
      // 预约数据
      serviceItemList: [],
      // 当前tab选中日期
      currentDate: "",
      // 当前选中时间
      currentTime: "",
      currentServeName: "",

      currentPrimaryKey: "", // 当前的PrimaryKey
      // 选中对象
      selectData: {}, // 切换判断是不是null 是null就轻提示
      WeekObj: {},
      // 可提前预约时间(ms)
      leadTime: 0,

      selectLabelList: {}, // 服务标签
    };
  },
  filters: {
    formatDate: utils.formatDate,
  },
  mounted() {
    this.getCommodityConfigIndo();
    this.getServiceDateList();
  },
  methods: {
    isCandidate(TimeObj, index) {
      let currentTime;
      let timeResult;
      let selectResult;
      let resultFlag = {};
      let nowTime;
      if (TimeObj) {
        if (!resultFlag[TimeObj.primaryKey]) {
          resultFlag[TimeObj.primaryKey] = {
            time: [],
            select: [],
          };
          TimeObj.businessHours.forEach((itemData) => {
            currentTime = this.currentDate + " " + itemData.startHours;
            currentTime = utils.getDate(currentTime).getTime();
            nowTime = new Date().getTime() + this.leadTime;
            resultFlag[TimeObj.primaryKey].time.push(
              nowTime >= currentTime || !itemData.flag ? "不可约" : "可约"
            );
            resultFlag[TimeObj.primaryKey].select.push(
              itemData.flag && nowTime <= currentTime ? "可约" : "不可约"
            );
            timeResult = resultFlag[TimeObj.primaryKey].time.every((value) => {
              return value === "不可约";
            });
            selectResult = resultFlag[TimeObj.primaryKey].select.every(
              (value) => {
                return value === "不可约";
              }
            );
          });
        }
      }
      return selectResult && timeResult;
    },
    // 候补
    handleCandidate(currentItem) {
      if (
        currentItem.speus.length &&
        !this.selectLabelList[currentItem.primaryKey]
      ) {
        this.$toast("请选择服务项");
        return;
      }
      sessionStorage.setItem(
        "candidate",
        JSON.stringify({
          merchantId: currentItem.merchantId, // 商户id
          shopId: this.$route.query.primaryKey,
          spuId: currentItem.primaryKey,
          presentDate: this.currentDate,
          name: currentItem.name,
          price: currentItem.price,
          unit: currentItem.unit,
          selectTimeData: [],
          additionalSpuName: this.isExist(
            this.selectLabelList,
            currentItem.primaryKey
          )
            ? this.selectLabelList[currentItem.primaryKey].selectNameList
            : [],
        })
      );
      this.$router.push({
        path: "beAnAlternate",
        query: {
          shopId: this.$route.query.primaryKey, //
          spuId: currentItem.primaryKey,
          presentDate: this.currentDate,
        },
      });
    },
    currentSeletdTime(speusItem, selectLabelList, selectData) {
      let projectItem = selectLabelList[speusItem.spuId];
      let selectLabel =
        projectItem && projectItem.selectLabel ? projectItem.selectLabel : [];
      const index = selectLabel.findIndex((item) => {
        return item.attributeName === speusItem.attributeName;
      });
      return index > -1;
    },
    selectItem(parentItem, itemData) {
      // parentItem 父亲的 itemData 是当前选择的
      let currentLabel = {};
      if (!this.selectLabelList[itemData.spuId]) {
        currentLabel = {
          selectLabel: [],
          selectNameList: [],
        };
      } else {
        currentLabel = Object.assign({}, this.selectLabelList[itemData.spuId]);
      }

      this.currentPrimaryKey = itemData.spuId;

      if (this.selectData) {
        if (this.selectData[itemData.spuId] === undefined) {
          this.selectData = {};
          this.currentTime = "";
        }
      }

      let currentSelectLabelData = currentLabel.selectLabel; // 当前的对象 08:00
      let currentSelectNameList = currentLabel.selectNameList; // 2020-11-19 08:00
      const index = currentSelectLabelData.findIndex((item) => {
        return item.attributeName === itemData.attributeName;
      });
      if (index > -1) {
        currentLabel.selectLabel.splice(index, 1);
        currentLabel.selectNameList.splice(index, 1);
      } else {
        // 添加限制：最多只能选择两个
        if (currentLabel.selectLabel.length >= 2) {
          this.$toast("最多选择两个服务项目");
          return;
        }
        currentLabel.selectLabel.push(itemData);
        currentLabel.selectNameList.push(itemData.attributeName);
      }
      this.selectLabelList = {};
      this.$set(this.selectLabelList, itemData.spuId, currentLabel);
    },
    async getCommodityConfigIndo() {
      let res = await commodityConfigIndo({
        commodityKey: this.$route.query.primaryKey,
      });
      this.leadTime =
        res.data && res.data.leadTime && !isNaN(Number(res.data.leadTime))
          ? Number(res.data.leadTime) * 60 * 1000
          : 0;
    },
    async getServiceDateList() {
      let res = await serviceDateList(this.$route.query.primaryKey);
      this.dateList = res.data;
      let setMakeAnAppointmentTime = sessionStorage.getItem(
        "setMakeAnAppointmentTime"
      );

      if (setMakeAnAppointmentTime) {
        this.selectData = JSON.parse(
          sessionStorage.getItem("setMakeAnAppointmentTime")
        );

        for (var key in this.selectData) {
          this.currentPrimaryKey = key;
          this.selectLabelList[key] = {
            selectNameList: [],
          };
          this.currentTime =
            this.selectData[key] && this.selectData[key].selectTimeList[0];
          this.currentDate = this.selectData[key].currentDate;
          this.currentServeName = this.selectData[key].name;
          this.selectLabelList[key].selectNameList = this.selectData[key]
            .additionalSpuName
            ? this.selectData[key].additionalSpuName
            : [];
          this.selectLabelList[key].selectLabel = this.selectData[key]
            .selectLabel
            ? this.selectData[key].selectLabel
            : [];
        }
      } else {
        this.currentDate = this.dateList.length ? this.dateList[0].dateStr : "";
      }

      if (this.dateList.length) {
        this.getServiceItemList();
      }
    },
    async getServiceItemList() {
      let res = await getMakeAnAppointmentTime({
        primaryKey: this.$route.query.primaryKey,
        presentDate: this.currentDate,
      });

      this.serviceItemList = res.data.rows;
      this.getCandidateStatus(this.$route.query.primaryKey);
    },
    handleCurrent(item) {
      if (this.currentDate !== item.dateStr) {
        this.currentDate = item.dateStr;
        this.getServiceItemList();
      }
    },
    async getCandidateStatus(primaryKey) {
      const res = await candidateStatus(primaryKey);
      this.dateList = res.data;
    },
    isExist(selectLabelList, currentPrimaryKey) {
      if (selectLabelList) {
        if (
          selectLabelList[currentPrimaryKey] &&
          selectLabelList[currentPrimaryKey].selectNameList.length > 0 &&
          selectLabelList[currentPrimaryKey].selectLabel.length > 0
        ) {
          return true;
        }
      }
    },
    handleImmediatelyBook() {
      if (
        !Object.keys(this.selectData).length == 0 &&
        this.isObj(Object.values(this.selectData)[0])
      ) {
        let currentKey;
        for (var key in this.selectData) {
          currentKey = key;
        }
        if (
          this.selectData[currentKey] &&
          this.selectData[currentKey].speus &&
          this.selectData[currentKey].speus.length > 0
        ) {
          if (this.isExist(this.selectLabelList, this.currentPrimaryKey)) {
            this.selectData[currentKey]["additionalSpuName"] =
              this.selectLabelList[this.currentPrimaryKey].selectNameList;
            this.selectData[currentKey]["selectLabel"] =
              this.selectLabelList[this.currentPrimaryKey].selectLabel;
          } else {
            this.$toast("请选择服务项");
            return;
          }
        }
        sessionStorage.setItem(
          "setMakeAnAppointmentTime",
          JSON.stringify(Object.assign(this.selectData))
        );
        this.$router.push({
          path: "/subscribeInside",
          query: {
            shopId: this.$route.query.primaryKey, // 理发的id
          },
        });
      } else {
        this.$toast("请选择服务时间");
      }
    },
    isObj(currentType) {
      return Object.prototype.toString.call(currentType) === "[object Object]";
    },
    // 选择预约
    setSelectTime(itemData, item) {
      if (!this.updateStatus(itemData)) {
        // 先判断对象中有没有 没有就添加
        // 获取当前对象 selectTimeList 判断有没有
        // currentdate 当前时间
        // 查看selectData里面是否之前选择过，选择过则继续追加，没选择过先创建在追加
        let currentSelectData = {};
        if (!this.selectData[item.primaryKey]) {
          currentSelectData = Object.assign(
            item,
            {
              currentDate: this.currentDate,
            },
            {
              selectTimeData: [],
              selectTimeList: [],
            }
          );
        } else {
          currentSelectData = Object.assign(
            {},
            this.selectData[item.primaryKey]
          );
        }
        if (this.selectLabelList) {
          if (this.selectLabelList[item.primaryKey] === undefined) {
            this.selectLabelList = {};
          }
        }
        let currentSelectTimeData = currentSelectData.selectTimeData; // 当前的对象 08:00
        let currentSelectTimeList = currentSelectData.selectTimeList; // 2020-11-19 08:00

        let selectTimeStr = this.currentDate + " " + itemData.startHours;
        let index = currentSelectTimeList.indexOf(selectTimeStr);

        if (index > -1) {
          currentSelectData = null;
          this.currentTime = "";
          this.currentServeName = "";
        } else {
          currentSelectTimeList = [selectTimeStr]; // 当前的服务的YYYY-MM-DD
          currentSelectTimeData = [itemData]; // 当前的对象
          currentSelectData.selectTimeList = currentSelectTimeList;
          currentSelectData.selectTimeData = currentSelectTimeData;
          currentSelectData["currentDate"] = this.currentDate;
          currentSelectData.subscribe =
            utils.formatDate(this.currentDate, "yyyy年MM月dd日") +
            " " +
            itemData.startHours +
            "的" +
            item.name +
            "服务";
          this.currentTime = selectTimeStr;
          this.currentServeName = currentSelectData.name;
        }

        this.selectData = {};
        this.$set(this.selectData, item.primaryKey, currentSelectData);
      } else {
        this.$toast("当前时段不可预约");
      }
    },
    /**
     *itemData: 当前选择对象
     *item: 服务对象
     */
    inquireSelect(item, itemData, selectData) {
      let projectItem = selectData[item.primaryKey];
      let selectTimeList =
        projectItem && projectItem.selectTimeList
          ? projectItem.selectTimeList
          : [];
      let selectTimeStr = this.currentDate + " " + itemData.startHours;
      let index = selectTimeList.indexOf(selectTimeStr);
      return index > -1;
    },
    updateStatus(itemData) {
      let currentTime = this.currentDate + " " + itemData.startHours;
      currentTime = utils.getDate(currentTime).getTime();
      // 当前时间加上提前预约时间
      let nowTime = new Date().getTime() + this.leadTime;
      return !itemData.flag || nowTime >= currentTime;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background: #eeeeee;
  padding: 0 12px 10px;

  .custom-image {
    /deep/ .van-empty__image {
      width: 90px;
      height: 90px;

      img {
        width: 90px;
        height: 90px;
      }
    }
  }
}

.page-flex-box {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
}

.date-box {
  margin-top: 10px;
  border-radius: 5px;
  background: #fff;
  overflow: hidden;
  padding: 10px 5px;

  .date-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow-x: auto;

    .date-item {
      flex-basis: 20%;
      flex-shrink: 0;
      white-space: nowrap;
      padding: 0 5px;
      text-align: center;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;

      .title {
        color: #333333;
      }
      .date {
        color: #666666;
      }
      .remark {
        color: #16aa77;
      }

      .active {
        border-radius: 5px;
        background: #16aa77;
        padding: 10px;

        .title,
        .date,
        .remark {
          color: #fff;
        }
      }
    }
  }
}

.content-box {
  flex: 1;
  overflow: auto;
}

.list-box {
  margin-top: 10px;
  border-radius: 5px;
  background: #fff;
  .banner-title-box {
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .banner-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin-right: 10px;
    }
    .item-price {
      display: flex;
      align-items: center;
      color: #16aa77;
      font-size: 16px;
      font-family: PingFangSC-Regular;
      font-weight: 600;
      .unit1 {
        font-size: 12px;
        font-family: PingFangSC-Semibold;
      }
      .unit2 {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        color: #666666;
      }
    }
  }

  .list-main {
    padding: 0 5px 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .list-item {
      width: 25%;
      height: 40px;
      padding: 0 5px;
      margin-bottom: 5px;

      .item-main {
        border-radius: 3px;
        border: 1px solid #eaeaea;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        color: #333;
        background: #fff;
        height: 100%;
      }

      .disabled {
        background: #f4f4f4;
        color: #666;
      }

      .active {
        border: 1px solid #16aa77;
        color: #16aa78;
        background: #fff;

        .check-icon {
          position: absolute;
          right: -1px;
          top: -1px;
          width: 17px;
          height: 17px;
        }
      }
    }
    .service-item {
      width: 20%;
      height: 43px;
      padding: 0 5px;
      margin-bottom: 5px;
      .service-main {
        border-radius: 3px;
        border: 1px solid #eaeaea;
        display: flex;
        font-weight: 500;
        align-items: center;
        justify-content: center;
        position: relative;
        color: #333;
        background: #fff;
        height: 100%;
      }

      .disabled {
        background: #f4f4f4;
        color: #666;
      }

      .active {
        border: 1px solid #16aa77;
        color: #16aa78;
        background: #fff;

        .check-icon {
          position: absolute;
          right: -1px;
          top: 0;
          width: 17px;
          height: 17px;
        }
      }
    }
    .candidate-item {
      width: 25%;
      height: 40px;
      padding: 0 5px;
      margin-bottom: 5px;
      .candidate-main {
        border-radius: 3px;
        border: 1px solid #eaeaea;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        position: relative;
        color: #ff9900;
        background: #fff;
        height: 100%;
        & > span:last-child {
          margin-left: 2px;
        }
      }
    }
  }
}
.appointment-box {
  padding: 15px 10px;
  .appointment-text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #16aa77;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .appointment-btn {
    background: #16aa77;
    border-radius: 20px;
    height: 40px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
  }
}
.public-title {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 22px;
}

.cancel-margin {
  margin-right: 0px !important;
}

.modality {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.long-line {
  width: 100%;
  height: 0.5px;
  background: rgba(216, 216, 216, 0.8);
}

.service-time {
  margin-top: 15px;

  .service-time-ul {
    display: flex;
    margin: 0px 15px;

    .service-time-ul-item {
      margin-right: 20px;

      .week {
        margin-bottom: 14px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #565457;
        line-height: 20px;
        letter-spacing: 1px;
      }

      .number-of-days {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 21px;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #565457;
        line-height: 21px;
      }

      .opt-active {
        width: 28px;
        height: 28px;
        background: #7ed4bc;
        border-radius: 50%;
      }

      .cancel-margin {
        margin: 0px !important;
      }
    }
  }
}

.service-category-box {
  flex: 1;
  overflow: auto;
}

.service-category {
  .service-category-top {
    display: flex;
    align-items: center;
    margin: 15px;

    .wash-cut-margin {
      margin-right: 7px;
    }

    .price {
      display: flex;
      align-items: center;
      height: 20px;
      line-height: 20px;

      .rem {
        line-height: 18px;
        height: 20px;
        font-size: 13px;
        color: #ea1e1b;
        margin-right: 5px;
      }

      .money {
        line-height: 18px;
        height: 20px;
        font-size: 17px;
        color: #ea1e1b;
      }

      .number {
        font-size: 12px;
        color: #ea1e1b;
      }
    }
  }

  .time-list {
    .time-list-ul {
      margin: 15px 10px 15px 15px;
      display: flex;
      flex-wrap: wrap;

      .time-list-ul-li {
        margin-right: 5px;
        margin-bottom: 5px;

        .min-box {
          width: 82px;
          height: 44px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2px;
          border: 1px solid #eaeaea;
          font-size: 13px;
          font-weight: bold;
          color: #666666;
          background: #ffffff;
        }

        .is-show {
          color: #000000 !important;
          background: #f4f4f4 !important;
        }

        .current-wash-cut {
          color: #21b957 !important;
          background: #f5fffa !important;
          border: 1px solid #21b957 !important;
        }

        .active {
          width: 82px;
          height: 44px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2px;
          background: #f5fffa;
          border: 1px solid #21b957;
        }
      }
    }
  }
}
.subscribe-shell {
  padding: 30px 15px 15px;
  width: 100%;

  .subscribe {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .info {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #21b957;
      line-height: 18px;
    }
    .van-button--primary {
      width: 93px;
      height: 27px;
      margin-left: 23px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #21b957;
      border-radius: 13px;
      .van-button__text {
        height: 16px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 16px;
      }
    }
  }
}
</style>
